import client from '../../client'

const tokenConfig = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`
  }
})

export function reqGetCreditOffer(token) {
  return client().get('/api/simulacion/oferta',
    tokenConfig(token))
}

export function reqGetCreditResult({ amount, cuotas, seguros, tipoTrabajador }, token) {
  const cesantia = seguros.cesantia
  const params = `monto=${amount}&cuotas=${cuotas}&seguroCesantia=${cesantia}&tipoTrabajador=${tipoTrabajador}`
  return client().get(`/api/simulacion?${params}`, tokenConfig(token))
}

export function reqCompletedProccess(simulationId, token) {
  console.log('Enviar solicitud ' + simulationId)
  return client().post('/api/simulacion/enviar-solicitud', {
    simulationId: simulationId
  }, tokenConfig(token))
}

export function reqGetMyStatusSolicitudCredito(token) {
  return client().get(`/api/solicitud-credito/my-solicitud-credito`, tokenConfig(token))
}

export function reqGetUserSolicitudesHistory(token, page) {
  const params = `page=${page}`
  return client().get(`/api/users/solicitudes-history?${params}`, tokenConfig(token))
}

export async function reqCompletedProcessDeclaracion(idDeclaracion, token) {
  console.log('reqCompletedProcessDeclaracion idDeclaracion: ', idDeclaracion);
  const declaracionJurada = {
    idRegistro: idDeclaracion,
    estado: 'ACEPTADA'
  }
  return await client().put('/api/declaracion-jurada/simple', declaracionJurada, tokenConfig(token));
}

export async function generarMcrDocumentos(token, data) {
  return await client().post('/api/mcr/orquestador/documentos', data, tokenConfig(token));
}